/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateWhatsAppMarkAllAsRead } from '../../axios/candidateWhatsAppMarkAllAsRead'
import type {
	CandidateWhatsAppMarkAllAsReadError,
	CandidateWhatsAppMarkAllAsReadPathParams,
	CandidateWhatsAppMarkAllAsReadResponse,
} from '../../types/CandidateWhatsAppMarkAllAsRead'

export const candidateWhatsAppMarkAllAsReadMutationKey = () =>
	[{ url: '/candidates/:candidateId/whatsapp/read-all' }] as const

export type CandidateWhatsAppMarkAllAsReadMutationKey = ReturnType<typeof candidateWhatsAppMarkAllAsReadMutationKey>

export type CandidateWhatsAppMarkAllAsReadVariables = {
	candidateId: CandidateWhatsAppMarkAllAsReadPathParams['candidateId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::markAllAsRead */
export function useCandidateWhatsAppMarkAllAsRead<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateWhatsAppMarkAllAsReadResponse,
		AxiosError<CandidateWhatsAppMarkAllAsReadError>,
		CandidateWhatsAppMarkAllAsReadVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateWhatsAppMarkAllAsReadMutationKey(),
		mutationFn: ({ candidateId }: CandidateWhatsAppMarkAllAsReadVariables) =>
			candidateWhatsAppMarkAllAsRead(candidateId, config).then(res => res.data),
		...options,
	})
}
